<ion-row>
    <ion-col size="12">
        <div class="timeline-container">
            <div class="line-container">
                <div class="line"></div>
                <div class="complete-line" [ngStyle]="fillLine"></div>
            </div>
            <div class="chip-relative" [ngClass]="{ 'first-pill': i === 0 }" *ngFor="let application of sortedApplicationChain; let i = index">
                <div class="chip-container-one">
                    <ion-chip
                        color="secondary"
                        mode="ios"
                        outline="true"
                        (click)="applicationSelected(application, i)"
                        [ngClass]="{
                            'completed-pill': applicationTimeline[i],
                            'selected-pill': selectedApplication === application
                        }"
                    >
                        <fa-icon [icon]="faCheck" *ngIf="applicationTimeline[i]"></fa-icon>
                        <p class="timeline-chip-text">
                            {{ selectedApplication === application ? timelineLabelFirst : '' }}
                        </p>
                    </ion-chip>
                    <div class="desktop-dates">
                        <ion-text>
                            <b
                                class="timeline-dates"
                                [ngClass]="{
                                    'selected-date': selectedApplication === application
                                }"
                                >{{ application.startdate | date: 'mediumDate':'UTC' }}
                                -
                                {{ application.enddate | date: 'mediumDate':'UTC' }}</b
                            >
                        </ion-text>
                    </div>
                </div>
            </div>
        </div>
    </ion-col>
</ion-row>
<ion-row class="mobile-dates">
    <ion-col size="12" class="ion-text-center">
        <p *ngIf="applicationDates?.startdate" class="application-dates">
            {{ applicationDates?.startdate | date: 'longDate':'UTC' }} -
            {{ applicationDates?.enddate | date: 'longDate':'UTC' }}
        </p>
    </ion-col>
</ion-row>
<div class="line-divider"></div>
<div class="applications-container" *ngIf="applicationChain$ | async as applications">
    <ion-slides pager="true" [options]="slideOpts" #mySlider>
        <ion-slide *ngFor="let application of applications; let i = index">
            <app-application-chain-card
                [application]="application"
                [selected]="selectedApplication === applications[i]"
                (click)="applicationSelected(application, i)"
                [ngClass]="[selectedApplication === applications[i] ? 'selected' : 'not-selected']"
            ></app-application-chain-card>
        </ion-slide>
    </ion-slides>
    <div class="swiper-buttons">
        <div class="swiper-button-prev arrow-btn" (click)="leftClick()"></div>
        <div class="swiper-button-next arrow-btn" (click)="rightClick()"></div>
    </div>
</div>
<div *ngIf="applicationChain$ | async as applications">
    <ion-row
        *ngIf="promptForMidRotationReview && showMidRotationReview === false && showPostRotationReview === false && status?.application?.states !== 'Completed'"
    >
        <ion-col size="12">
            <ion-row class="ion-justify-content-center">
                <ion-col class="ion-justify-content-center" size-sm="12" size-md="12" size-lg="6" size-xl="6">
                    <ion-card class="card-1 list-card" style="margin-bottom: 1em; margin-top: 1em">
                        <ion-card-header>
                            <ion-text color="secondary">
                                <h2 class="ion-text-center ion-text-wrap">Complete Your Mid-Rotation Review</h2>
                            </ion-text>
                        </ion-card-header>
                        <ion-card-content>
                            <div class="ion-text-center">
                                <ion-text>
                                    <p>You have completed half of your clinical experience. Let us know how things are going.</p>
                                    <ion-button (click)="submitMidRotationReview()">
                                        <ion-text class="ion-text-wrap bold"> Complete Review </ion-text>
                                    </ion-button>
                                </ion-text>
                            </div>
                        </ion-card-content>
                    </ion-card>
                </ion-col>
            </ion-row>
        </ion-col>
    </ion-row>
    <ion-row class="ion-justify-content-center">
        <ion-col class="ion-justify-content-center">
            <app-review *ngIf="showMidRotationReview === true" [reviewType]="'mid'" [status]="status"></app-review>
            <app-review *ngIf="showPostRotationReview === true" [reviewType]="'post'" [status]="status"></app-review>
        </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center">
        <ion-col size-lg="8" size-xl="6" size-md="12" size-sm="12" size-xs="12">
            <app-complete *ngIf="status?.application.states === 'Completed'" [status]="status"></app-complete>
        </ion-col>
    </ion-row>
    <ion-row *ngIf="showMidRotationReview === false && showPostRotationReview === false">
        <ion-segment (ionChange)="segmentChanged($event)" *ngIf="status?.application.states !== 'Completed'" value="checklist" mode="md">
            <ion-segment-button class="segment-button-parent" value="checklist" mode="md">
                <ion-label class="segment-button"> First-Day Checklist </ion-label>
            </ion-segment-button>
            <ion-segment-button class="segment-button-parent" value="documents" mode="md">
                <ion-label class="segment-button"> Documents </ion-label>
            </ion-segment-button>
            <ion-segment-button class="segment-button-parent" value="program" mode="md">
                <ion-label class="segment-button"> Program Details </ion-label>
            </ion-segment-button>
        </ion-segment>
    </ion-row>
    <div class="segment-container" *ngIf="showMidRotationReview === false && showPostRotationReview === false && status?.application?.states !== 'Completed'">
        <app-application-chain-firstday-checklist *ngIf="showChecklist" [selectedApplication]="selectedApplication"></app-application-chain-firstday-checklist>
        <app-application-chain-document-list
            *ngIf="showDocuments"
            [chainedApplications]="chainedApplications"
            [profile]="profile"
            [applicationChainState]="applicationChainState"
        ></app-application-chain-document-list>
        <app-program-summary *ngIf="showProgram" [program]="selectedProgram" [user]="chainedApplications[0].User"></app-program-summary>
    </div>
</div>
